import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthController } from 'src/app/domain/controllers/auth.controller';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    private _authController = inject(AuthController);

    public canActivate(): boolean {
        const isLoggedIn = this._authController.isLoggedIn();
        if (!isLoggedIn) {
            this._authController.logout();
            return false;
        }

        return true;
    }
}
